module.exports = __webpack_public_path__ + "img/BlinkArt_Sword15_Iron.1b66f7d6.png";